import { Selectbox } from '@policygenius/mortar';
import React from 'react';

import { FieldRenderProps } from 'forms/types';
import getErrorMessage from 'forms/utils/getErrorMessage';

import styles from '../form-inputs.module.scss';
import { BaseSelectFieldProps } from './types';

export type SelectFieldProps<Value> = BaseSelectFieldProps &
  FieldRenderProps<Value, HTMLSelectElement, string>;

const SelectField = <Value extends string | number>({
  id,
  input,
  meta,
  ...props
}: SelectFieldProps<Value>) => (
  <div className={styles['field-container']}>
    <Selectbox
      {...input}
      {...props}
      id={id ?? input.name}
      value={input.value ?? undefined}
      errorMessage={getErrorMessage(meta)}
      defaultValue={meta.initial}
    />
  </div>
);

export default SelectField;
